export default class Header {
    constructor($header) {
        this.firstMenuTrigger = true;
        this.$header = $header;
        this.$menu = $header.querySelector('[data-menu]');
        this.$menuTrigger = $header.querySelector('[data-trigger-menu]');
        this.$subMenuTriggers = $header.querySelectorAll('[data-trigger-submenu]');
        this.$subsubMenuTriggers = $header.querySelectorAll('[data-trigger-subsubmenu]');

        this.checkSticky = this.checkSticky.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.openMenu = this.openMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.toggleSubMenu = this.toggleSubMenu.bind(this);
        this.toggleSubSubMenu = this.toggleSubSubMenu.bind(this);

        this.$menuTrigger.addEventListener('click', this.toggleMenu);
        this.$subMenuTriggers.forEach($trigger => $trigger.addEventListener('click', this.toggleSubMenu));
        this.$subsubMenuTriggers.forEach($trigger => $trigger.addEventListener('click', this.toggleSubSubMenu));

        window.addEventListener('scroll', this.checkSticky);

        document.addEventListener('click', (event) => {
            var isClickInsideElement = this.$menu.contains(event.target) || event.target === this.$menuTrigger || this.$menuTrigger.contains(event.target);
            if (!isClickInsideElement && this.$menu.classList.contains('header__menus--open')) {
                this.closeMenu();
            }
        });
    }

    openMenu(e) {
        e.preventDefault();
        this.$menu.classList.add('header__menus--open');
        this.$menu.classList.remove('header__menus--close');
        this.$menuTrigger.classList.add('header__menu-trigger--open');
        document.querySelector('body').classList.add('no-scroll');
    }

    closeMenu() {
        this.$menu.classList.remove('header__menus--open');
        this.$menu.classList.add('header__menus--close');
        this.$menuTrigger.classList.remove('header__menu-trigger--open');
        document.querySelector('body').classList.remove('no-scroll');
    }

    toggleMenu(e) {
        e.preventDefault();
        this.$menu.classList.toggle('header__menus--open');
        if(! this.firstMenuTrigger) {
            this.$menu.classList.toggle('header__menus--close');
        }
        this.$menuTrigger.classList.toggle('header__menu-trigger--open');
        document.querySelector('body').classList.toggle('no-scroll');
        this.firstMenuTrigger = false;
    }

    toggleSubMenu(e) {
        e.preventDefault();
        const subMenuId = e.target.dataset.triggerSubmenu;

        e.target.classList.toggle('header__bottom-nav-menu-link--active');
        this.$header.querySelector('[data-submenu="' + subMenuId + '"]').classList.toggle('sub-header__bottom-nav-menu--open');
    }

    toggleSubSubMenu(e) {
        if (window.innerWidth < 1140) {
            e.preventDefault();
        }
        const subsubMenuId = e.target.dataset.triggerSubsubmenu;

        e.target.classList.toggle('sub-header__bottom-nav-menu-link--active');
        this.$header.querySelector('[data-subsubmenu="' + subsubMenuId + '"]').classList.toggle('sub-header__bottom-nav-menu--open');
    }

    checkSticky() {
        let scrollPosition = window.pageYOffset;

        if (scrollPosition > 0) {
            this.$header.classList.add('header--shadow');
        } else {
            this.$header.classList.remove('header--shadow');
        }
    }
}